// TODO: Add better Forbidden component with details of reason
export const Forbidden = () => {
  return (
    <div className='w-full py-4 text-center text-xl font-bold'>Forbidden</div>
  );
};
